import { render } from "./SelectedEmployee.vue?vue&type=template&id=6ea34be5&scoped=true"
import script from "./SelectedEmployee.vue?vue&type=script&lang=js"
export * from "./SelectedEmployee.vue?vue&type=script&lang=js"

import "./SelectedEmployee.vue?vue&type=style&index=0&id=6ea34be5&lang=scss&scoped=true"

import exportComponent from "/opt/karibu-hrms/src/client/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-6ea34be5"]])

export default __exports__